var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-portlet-base',{ref:"portletBase",staticClass:"portlet col-span-4 row-span-4 placeholder-card",attrs:{"loading":_vm.loading}},[(!_vm.loading)?_c('div',{staticClass:"loading-message"},[_vm._v("No vendor data to display")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }